// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetV1Nonce (params?: {}): Promise<implicitReturnType>;
    publicGetV1Time (params?: {}): Promise<implicitReturnType>;
    publicGetV1Assets (params?: {}): Promise<implicitReturnType>;
    publicGetV1AssetsSymbol (params?: {}): Promise<implicitReturnType>;
    publicGetV1Markets (params?: {}): Promise<implicitReturnType>;
    publicGetV1MarketsSymbol (params?: {}): Promise<implicitReturnType>;
    publicGetV1HistoryMarketsSymbol (params?: {}): Promise<implicitReturnType>;
    publicGetV1MarketsSymbolOrderbookHybrid (params?: {}): Promise<implicitReturnType>;
    publicGetV1MarketsSymbolTrades (params?: {}): Promise<implicitReturnType>;
    publicGetV1MarketsSymbolTick (params?: {}): Promise<implicitReturnType>;
    publicGetV1MarketsSymbolCandle (params?: {}): Promise<implicitReturnType>;
    publicGetV1HistoryMarketsSymbolTrades (params?: {}): Promise<implicitReturnType>;
    publicGetV1HistoryMarketsSymbolFundingRate (params?: {}): Promise<implicitReturnType>;
    publicGetV1IndexPrices (params?: {}): Promise<implicitReturnType>;
    publicGetV1IndexPricesAssetSymbol (params?: {}): Promise<implicitReturnType>;
    publicGetV1ExpiryPricesSymbol (params?: {}): Promise<implicitReturnType>;
    publicGetV1OptionLadder (params?: {}): Promise<implicitReturnType>;
    publicGetV1OptionLadderSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetV2Orders (params?: {}): Promise<implicitReturnType>;
    privateGetV2HistoryOrders (params?: {}): Promise<implicitReturnType>;
    privateGetV2OrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetV2AmmInstructions (params?: {}): Promise<implicitReturnType>;
    privateGetV2AmmInstructionsInstructionId (params?: {}): Promise<implicitReturnType>;
    privateGetV1WalletsTransactions (params?: {}): Promise<implicitReturnType>;
    privateGetV1WalletsLimitsSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetV1WalletsDepositInstructionsCryptoSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetV1WalletsWithdrawalInstructionsCryptoSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetV1WalletsDepositInstructionsFiatSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetV1WalletsWithdrawalInstructionsFiatSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetV1WalletsSelfHostedVerificationAttempts (params?: {}): Promise<implicitReturnType>;
    privateGetV1Trades (params?: {}): Promise<implicitReturnType>;
    privateGetV1HistoryTrades (params?: {}): Promise<implicitReturnType>;
    privateGetV1TradesTradeId (params?: {}): Promise<implicitReturnType>;
    privateGetV1TradesClientOrderIdClientOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetV1AccountsAsset (params?: {}): Promise<implicitReturnType>;
    privateGetV1AccountsAssetSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetV1UsersLogout (params?: {}): Promise<implicitReturnType>;
    privateGetV1UsersHmacLogin (params?: {}): Promise<implicitReturnType>;
    privateGetV1AccountsTradingAccounts (params?: {}): Promise<implicitReturnType>;
    privateGetV1AccountsTradingAccountsTradingAccountId (params?: {}): Promise<implicitReturnType>;
    privateGetV1DerivativesPositions (params?: {}): Promise<implicitReturnType>;
    privateGetV1HistoryDerivativesSettlement (params?: {}): Promise<implicitReturnType>;
    privateGetV1HistoryTransfer (params?: {}): Promise<implicitReturnType>;
    privateGetV1HistoryBorrowInterest (params?: {}): Promise<implicitReturnType>;
    privateGetV2MmpConfiguration (params?: {}): Promise<implicitReturnType>;
    privateGetV2OtcTrades (params?: {}): Promise<implicitReturnType>;
    privateGetV2OtcTradesOtcTradeId (params?: {}): Promise<implicitReturnType>;
    privateGetV2OtcTradesUnconfirmedTrade (params?: {}): Promise<implicitReturnType>;
    privatePostV2Orders (params?: {}): Promise<implicitReturnType>;
    privatePostV2Command (params?: {}): Promise<implicitReturnType>;
    privatePostV2AmmInstructions (params?: {}): Promise<implicitReturnType>;
    privatePostV1WalletsWithdrawal (params?: {}): Promise<implicitReturnType>;
    privatePostV2UsersLogin (params?: {}): Promise<implicitReturnType>;
    privatePostV1SimulatePortfolioMargin (params?: {}): Promise<implicitReturnType>;
    privatePostV1WalletsSelfHostedInitiate (params?: {}): Promise<implicitReturnType>;
    privatePostV2MmpConfiguration (params?: {}): Promise<implicitReturnType>;
    privatePostV2OtcTrades (params?: {}): Promise<implicitReturnType>;
    privatePostV2OtcCommand (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
